module.exports = __webpack_public_path__ + "static/img/znjzt.70ad546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/znjzt.png
// module id = 19lm
// module chunks = 1